var defaultOptions = {};
export function getDefaultOptions() {
  return defaultOptions;
}
export function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/defaultOptions/index.js
// module id = 97
// module chunks = 0